module.exports = __webpack_public_path__ + "images/category_lp/camera/new/assessment_achievements/4@2x_a6545b290b11efc04827370654f62f4f.png";